import { __awaiter } from "tslib";
import Amplify, { Auth } from 'aws-amplify';
import env from './env';
const { aws, apiBaseURL } = env;
Amplify.configure({
    Auth: {
        region: aws.region,
        userPoolId: aws.cognitoUserPoolId,
        identityPoolId: aws.identityPoolId,
        mandatorySignIn: false,
        userPoolWebClientId: aws.cognitoClientId
    },
    Storage: {
        AWSS3: {
            bucket: aws.publicBucket,
            region: aws.region
        }
    },
    API: {
        endpoints: [
            {
                name: 'public',
                region: aws.region,
                endpoint: apiBaseURL + '/public/'
            },
            {
                name: 'console',
                region: aws.region,
                endpoint: apiBaseURL + '/console/',
                custom_header: () => __awaiter(void 0, void 0, void 0, function* () {
                    let session = yield Auth.currentSession();
                    if (session.getIdToken() == null) {
                        throw new Error('Auth Error');
                    }
                    let idToken = session.getIdToken();
                    if (idToken.payload.exp * 1000 < Date.now()) {
                        yield Auth.currentUserCredentials();
                        yield new Promise(done => setTimeout(done, 1000));
                    }
                    return {
                        Accept: 'application/json',
                        Authorization: idToken.getJwtToken()
                    };
                })
            }
        ]
    }
});
